export const SHIP_TYPES = {
  TUG: 'Tug',
  TANKER: 'Tanker',
  PASSENGER: 'Passenger Ship',
  CARGO: 'Cargo Ship',
  FISHING: 'Fishing',
  MILITARY: 'Military Vessel',
  DEFAULT: 'Default'
};

export const SHIP_COLORS = {
  [SHIP_TYPES.TUG]: '#00ff00',      // Bright Green
  [SHIP_TYPES.TANKER]: '#ff0000',   // Bright Red
  [SHIP_TYPES.PASSENGER]: '#0066ff', // Bright Blue
  [SHIP_TYPES.CARGO]: '#ffa500',    // Bright Orange
  [SHIP_TYPES.FISHING]: '#ff00ff',   // Bright Magenta
  [SHIP_TYPES.MILITARY]: '#000080',  // Navy Blue
  [SHIP_TYPES.DEFAULT]: '#000000',   // Black
};

export const getShipColor = (shipType) => {
  if (!shipType) return SHIP_COLORS[SHIP_TYPES.DEFAULT];
  
  const matchingType = Object.values(SHIP_TYPES).find(type => 
    shipType.toLowerCase().includes(type.toLowerCase())
  );
  
  return SHIP_COLORS[matchingType] || SHIP_COLORS[SHIP_TYPES.DEFAULT];
}; 